// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportStory_wrapper__SHfZu","item":"ReportStory_item__TtwaH","input":"ReportStory_input__hDwAC","checkbox":"ReportStory_checkbox__lGGRb"};